import { useMemo } from 'react';
import { useWindowSize } from '../../utils';
import { themeBreakpoints } from '../foundations/breakpoints';
export var useBreakpoint = function useBreakpoint() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    defaultBreakpoint = 'xs',
    debounce = 500
  } = options;
  var {
    width: screenWidth
  } = useWindowSize({
    debounce
  });

  var getScreenCurrentBreakpoint = screenSize => {
    var matchBreakpoint;
    var keys = Object.keys(themeBreakpoints);
    var values = Object.values(themeBreakpoints);
    var index = 0; // Iterate through breakpoints to find the matching size

    for (var value of values) {
      var _values;

      var currentBreakpointValue = parseInt(value, 10);
      var nextBreakpointValue = parseInt((_values = values[index + 1]) !== null && _values !== void 0 ? _values : themeBreakpoints.xl, 10); // check if the screen size is between the current breakpoint value and the next breakpoint value

      if (currentBreakpointValue <= screenSize && screenSize < nextBreakpointValue) {
        matchBreakpoint = keys[index];
        break;
      }

      index = index + 1;
    } // Set size to the largest matching breakpoint or 'xl' if no match found


    if (!matchBreakpoint) {
      matchBreakpoint = 'xl';
    }

    return matchBreakpoint;
  };

  var breakpointKey = useMemo(() => {
    var _window$innerWidth;

    return screenWidth ? getScreenCurrentBreakpoint(screenWidth) : getScreenCurrentBreakpoint((_window$innerWidth = window.innerWidth) !== null && _window$innerWidth !== void 0 ? _window$innerWidth : parseInt(themeBreakpoints[defaultBreakpoint], 10));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [window.innerWidth, screenWidth]);
  return {
    breakpoint: breakpointKey !== null && breakpointKey !== void 0 ? breakpointKey : defaultBreakpoint,
    isExtraSmallScreen: breakpointKey === 'xs',
    isSmallScreen: breakpointKey === 's',
    isMediumScreen: breakpointKey === 'm',
    isLargeScreen: breakpointKey === 'l',
    isExtraLargeScreen: breakpointKey === 'xl'
  };
};
//# sourceMappingURL=useBreakpoint.js.map